import url_ from "asset-data:assets/galleries/featured/plane_c7145133d4__800.jpg";
export const url = url_;